import styled from "styled-components";

export const ProfileActionButton = styled.button`
    background: transparent;
    border: none;
    padding: 2px 0;
    cursor: pointer;
    font-family: ${(props) => props.theme.font.family};
    font-size: ${(props) => props.theme.font.sizes.md};
    font-weight: ${(props) => props.theme.font.weights.regular};
    color: ${(props) => props.theme.palette.accent.light};
    text-decoration: none;
    transition: color 0.15s ease;

    &:hover {
        text-decoration: underline;
    }

    &:focus-visible {
        outline: none;
        box-shadow: ${(props) => props.theme.shadowTypes.buttonFocus};
        border-radius: ${(props) => props.theme.shape.borderRadiusSm}px;
    }
`;

export const ThemeToggleRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
`;

export const ThemeToggleLabel = styled.span`
    font-family: ${(props) => props.theme.font.family};
    font-size: ${(props) => props.theme.font.sizes.md};
    color: ${(props) => props.theme.palette.text.main};
    display: inline-flex;
    align-items: center;
    gap: 6px;
`;

export const ThemeToggleSwitch = styled.button<{ $checked: boolean }>`
    position: relative;
    width: 40px;
    height: 22px;
    border-radius: 999px;
    border: 1px solid ${(props) => (props.$checked ? props.theme.palette.accent.dark : props.theme.palette.grey)};
    background: ${(props) => (props.$checked ? props.theme.palette.accent.dark : props.theme.palette.grey)};
    cursor: pointer;
    padding: 0;
    flex-shrink: 0;
    transition: background-color 0.15s ease, border-color 0.15s ease;

    &:hover {
        border-color: ${(props) => props.theme.palette.accent.dark};
    }

    &:focus-visible {
        outline: none;
        box-shadow: ${(props) => props.theme.shadowTypes.buttonFocus};
    }

    &::after {
        content: "";
        position: absolute;
        top: 2px;
        left: ${(props) => (props.$checked ? "20px" : "2px")};
        width: 16px;
        height: 16px;
        border-radius: 50%;
        background: ${(props) => props.theme.palette.white};
        transition: left 0.15s ease;
    }
`;